const langdata = {
  eng: {
    btnTextToTab: {
      "ALL TABS": "all_indices",
      "THE HOLY QURAN": "holyQuran",
      "URDU JAMAAT BOOKS": "books",
      "ENGLISH JAMAAT BOOKS": "engBooks",
      "ARABIC BOOKS": "arabicBooks",
      "GERMAN BOOKS":"germanBooks",
      "ASK ISLAM": "askislam",
      "DARSUL-QURAN": "darsulQuran",
      "MTA MATERIAL": "mtmMaterial",
      "FRIDAY SERMON": "fridaySermon",
      "HISTORY":"history",
      "PERIODICALS": "periodicals"
    },
    queryTextToTab: {
      "HYBRID MATCH": "Hybrid Match",
      "PHRASE MATCH":  "Phrase Match",
      "TERM MATCH (OR)": "Term Match (OR)",
      "TERM MATCH (AND)":  "Term Match (AND)",
    },
    sortTextToTab: {
      "CHRONOLOGICAL ORDER": "chronological",
      "RELEVANCE ORDER": "relevance",
    },
    buttons: {
      "Search": "Search",
      "Advanced Filters": "Advanced Filters",
      "Back": "Back",
      "Feedback": "Feedback",
      "Bookmarks": "Bookmarks",
      "About Us": "About Us",
      "Settings": "Settings",
      "Next Page": "Next Page",
      "Previous Page": "Previous Page",
      "Select all": "Select all",
      "Open Youtube link": "Open Youtube link",
      "Open Original Link": "Open Original Link",
      "Open page in Book": "Open Page in Book",
      "Next": "Next",
      'Previous': "Previous",
      "Paragraph": "Paragraph",
      "Page": "Page",
      "submit": "Submit",
      "subject": "Subject",
      "select all": "Select All",
      "select all malfozat": "Select all Malfoozat volumes",
      "select all tk": "Select all Tafsir kabir volumes",
    },
    filtersTitle:{
        'books':    'Jamati Books',
        'engBooks': 'English Jamaat Books',
        'arabicBooks': 'Arabic Books',
        'holyQuran': 'The Holy Quran',
        'mtmMaterial': 'MTA Material',
        'fridaySermon': 'Friday Sermon',
        'germanBooks': 'German Books',
        'periodicals': 'Periodicals'
    },
    Authors: {
      "7m1htVft": "Hazrat Masih Maud (as)",
      "TmSGrSKz": "Written by Scholars",
      "toFJPQP6": "Hazrat Khalifa-e-Waqt (aba)",
      "dgR347Hl": "Hazrat Musleh-e-Maud (ra)",
      "d4x7soWD": "Hazrat Khalifatul Masih IV (Rahmat Allah Alayhi)",
    },
    Author:'Authors',
    "disclaimer": "",
  },
  ar: {
    btnTextToTab: {
      "\u0643\u0644 \u0627\u0644\u062D\u0642\u0648\u0644": "all_indices",
      "\u0627\u0644\u0642\u0631\u0622\u0646 \u0627\u0644\u0643\u0631\u064A\u0645": "holyQuran",
      "\u0643\u062A\u0628 \u0627\u0644\u062C\u0645\u0627\u0639\u0629 \u0628\u0627\u0644\u0623\u0631\u062F\u064A\u0629": "books",
      "\u0643\u062A\u0628 \u0627\u0644\u062C\u0645\u0627\u0639\u0629 \u0628\u0627\u0644\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629": "engBooks",
      "\u0643\u062A\u0628 \u0627\u0644\u062C\u0645\u0627\u0639\u0629 \u0628\u0627\u0644\u0639\u0631\u0628\u064A\u0629": "arabicBooks",
      "\u0627\u0644\u0643\u062A\u0628 \u0627\u0644\u0623\u0644\u0645\u0627\u0646\u064A\u0629": "germanBooks",
      "\u0627\u0633\u0623\u0644 \u0627\u0644\u0625\u0633\u0644\u0627\u0645 (\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629)": "askislam",
      "\u062F\u0631\u0633 \u0627\u0644\u0642\u0631\u0622\u0646 (\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629)": "darsulQuran",
      "\u0645\u0648\u0627\u062F MTA": "mtmMaterial",
      "\u062E\u0637\u0628 \u0627\u0644\u062C\u0645\u0639\u0629 (\u0623\u0631\u062F\u064A\u0629 \u0648\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629)": "fridaySermon",
      "\u0627\u0644\u062A\u0627\u0631\u064A\u062E": "history",
      "\u0627\u0644\u062F\u0648\u0631\u064A\u0627\u062A": "periodicals"
    },
    queryTextToTab: {

      "\u062A\u0637\u0627\u0628\u0642 \u0639\u0627\u0645\u0651": "Hybrid Match",
      "\u062A\u0637\u0627\u0628\u0642 \u0643\u0644\u0651\u064A": "Phrase Match",
      "\u062A\u0637\u0627\u0628\u0642 \u0627\u0644\u0639\u0628\u0627\u0631\u0627\u062A (\u0623\u0648)": "Term Match (OR)",
    "\u062A\u0637\u0627\u0628\u0642 \u0627\u0644\u0639\u0628\u0627\u0631\u0627\u062A (\u0648)": "Term Match (AND)",
    },
    sortTextToTab: {
      "\u0627\u0644\u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0632\u0645\u0646\u064A": "chronological",
      "\u062A\u0631\u062A\u064A\u0628 \u0627\u0644\u0635\u0644\u0629": "relevance",
    },
    buttons: {
      "Search": "\u0628\u062D\u062B",
      "Advanced Filters": "\u062E\u064A\u0627\u0631\u0627\u062A \u0645\u062A\u0642\u062F\u0645\u0629",
      "Back": "\u0631\u062C\u0648\u0639",
      "Feedback": "\u0645\u0644\u0627\u062D\u0638\u0627\u062A",
      "Bookmarks": "\u0627\u0644\u0639\u0644\u0627\u0645\u0627\u062A \u0627\u0644\u0645\u0631\u062C\u0639\u064A\u0629",
      "About Us": "\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0639\u0646\u0627",
      "Settings": "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
      "Next Page": "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
      "Previous Page": "\u0627\u0644\u0635\u0641\u062D\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
      "Select all": "\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0643\u0644",
      "Open Youtube link": "\u0641\u062A\u062D \u0631\u0627\u0628\u0637 \u064A\u0648\u062A\u064A\u0648\u0628",
      "Open Original Link": "\u0641\u062A\u062D \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0623\u0635\u0644\u064A",
      "Open page in Book": "\u0641\u062A\u062D \u0627\u0644\u0635\u0641\u062D\u0629 \u0641\u064A \u0627\u0644\u0643\u062A\u0627\u0628",
      "Next": "\u0627\u0644\u062A\u0627\u0644\u064A",
      "Previous": "\u0627\u0644\u0633\u0627\u0628\u0642",
      "Paragraph": "\u0641\u0642\u0631\u0629",
      "Page": "\u0635\u0641\u062D\u0629",
      "submit": "\u0642\u062F\u0645",
      "subject": "\u0645\u0648\u0636\u0648\u0639",
      "select all": "\u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0643\u0644",
      "select all malfozat": "\u062A\u062D\u062F\u064A\u062F \u062C\u0645\u064A\u0639 \u0645\u062C\u0644\u062F\u0627\u062A \u0627\u0644\u0645\u0644\u0641\u0648\u0638\u0627\u062A",
      "select all tk": "\u062A\u062D\u062F\u064A\u062F \u062C\u0645\u064A\u0639 \u0645\u062C\u0644\u062F\u0627\u062A \u062A\u0641\u0633\u064A\u0631 \u0627\u0644\u0643\u0628\u064A\u0631",
    },
    filtersTitle :{
      'books':    '\u0643\u062A\u0628 \u0627\u0644\u062C\u0645\u0627\u0639\u0629 \u0628\u0627\u0644\u0623\u0631\u062F\u064A\u0629',
      'engBooks': '\u0643\u062A\u0628 \u0627\u0644\u062C\u0645\u0627\u0639\u0629 \u0628\u0627\u0644\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629',
      'arabicBooks': '\u0643\u062A\u0628 \u0627\u0644\u062C\u0645\u0627\u0639\u0629 \u0628\u0627\u0644\u0639\u0631\u0628\u064A\u0629',
      'holyQuran': '\u0627\u0644\u0642\u0631\u0622\u0646 \u0627\u0644\u0643\u0631\u064A\u0645',
      'mtmMaterial': '\u0645\u0648\u0627\u062F MTA',
      'fridaySermon': '\u062E\u0637\u0628 \u0627\u0644\u062C\u0645\u0639\u0629 (\u0623\u0631\u062F\u064A\u0629 \u0648\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629)',
      'germanBooks': '\u0627\u0644\u0643\u062A\u0628 \u0627\u0644\u0623\u0644\u0645\u0627\u0646\u064A\u0629',
      'periodicals': '\u0627\u0644\u062F\u0648\u0631\u064A\u0627\u062A'
  },
    Authors: {
      "7m1htVft": "\u062D\u0636\u0631\u0629 \u0627\u0644\u0645\u0633\u064A\u062D \u0627\u0644\u0645\u0648\u0639\u0648\u062F \u0639\u0644\u064A\u0647 \u0627\u0644\u0633\u0644\u0627\u0645",
      "TmSGrSKz": "\u0639\u0644\u0645\u0627\u0621 \u0627\u0644\u062C\u0645\u0627\u0639\u0629",
      "toFJPQP6": "\u062D\u0636\u0631\u0629 \u062E\u0644\u064A\u0641\u0629 \u0627\u0644\u0648\u0642\u062A \u0623\u064A\u062F\u0647 \u0627\u0644\u0644\u0647",
      "dgR347Hl": "\u062D\u0636\u0631\u0629 \u0627\u0644\u0645\u0635\u0644\u062D \u0627\u0644\u0645\u0648\u0639\u0648\u062F \u0631\u0636\u064A \u0627\u0644\u0644\u0647 \u0639\u0646\u0647",
      "d4x7soWD": "\u062D\u0636\u0631\u0629 \u062E\u0644\u064A\u0641\u0629 \u0627\u0644\u0645\u0633\u064A\u062D \u0627\u0644\u0631\u0627\u0628\u0639 \u0631\u062D\u0645\u0647 \u0627\u0644\u0644\u0647",
    },
    Author:'\u0627\u0644\u0643\u062A\u0651\u0627\u0628',

    disclaimer: "",
  },
};

export default langdata;
